import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { validarTokenClave, definirClaveApi } from '../services/api';

export default function DefinirClave() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';

  const [estado, setEstado] = useState('validando'); // validando | ok | invalido | listo
  const [email, setEmail] = useState('');
  const [motivo, setMotivo] = useState('');
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let vivo = true;
    if (!token) { setEstado('invalido'); setMotivo('El enlace no trae token.'); return; }
    validarTokenClave(token)
      .then(({ data }) => { if (vivo) { setEmail(data.email || ''); setEstado('ok'); } })
      .catch((err) => { if (vivo) { setMotivo(err.response?.data?.error || 'Enlace inválido o expirado'); setEstado('invalido'); } });
    return () => { vivo = false; };
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 6) return setError('La contraseña debe tener al menos 6 caracteres.');
    if (form.password !== form.confirm) return setError('Las contraseñas no coinciden.');
    setLoading(true);
    try {
      await definirClaveApi(token, form.password);
      setEstado('listo');
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo definir la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <div style={styles.logo}>ERP</div>
          <h1 style={styles.title}>Definir contraseña</h1>
          <p style={styles.subtitle}>
            {estado === 'ok' ? 'Crea tu contraseña para entrar a SnelERP' : 'SnelERP'}
          </p>
        </div>

        {estado === 'validando' && (
          <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 14 }}>Validando el enlace…</p>
        )}

        {estado === 'invalido' && (
          <>
            <div style={styles.error}>{motivo}</div>
            <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, marginTop: 8 }}>
              Pídele al administrador que te reenvíe el correo de bienvenida.
            </p>
            <p style={{ textAlign: 'center', marginTop: 16 }}>
              <Link to="/login" style={styles.link}>Ir a iniciar sesión</Link>
            </p>
          </>
        )}

        {estado === 'listo' && (
          <>
            <div style={styles.ok}>Contraseña creada. Ya puedes iniciar sesión.</div>
            <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, marginTop: 8 }}>Te llevamos al inicio de sesión…</p>
          </>
        )}

        {estado === 'ok' && (
          <form onSubmit={handleSubmit}>
            {error && <div style={styles.error}>{error}</div>}
            {email && (
              <div style={styles.field}>
                <label style={styles.label}>Usuario</label>
                <input style={{ ...styles.input, opacity: 0.7 }} value={email} readOnly />
              </div>
            )}
            <div style={styles.field}>
              <label style={styles.label}>Nueva contraseña</label>
              <input style={styles.input} type="password" value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                placeholder="••••••••" autoComplete="new-password" required />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Repetir contraseña</label>
              <input style={styles.input} type="password" value={form.confirm}
                onChange={e => setForm({ ...form, confirm: e.target.value })}
                placeholder="••••••••" autoComplete="new-password" required />
            </div>
            <button style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }} type="submit" disabled={loading}>
              {loading ? 'Guardando…' : 'Definir contraseña'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' },
  card: { background: '#1e293b', borderRadius: 16, padding: '40px 36px', width: '100%', maxWidth: 400, boxShadow: '0 25px 50px rgba(0,0,0,0.5)' },
  header: { textAlign: 'center', marginBottom: 28 },
  logo: { display: 'inline-block', background: '#3b82f6', color: '#fff', borderRadius: 12, padding: '10px 18px', fontSize: 20, fontWeight: 700, letterSpacing: 2, marginBottom: 16 },
  title: { color: '#f1f5f9', fontSize: 22, fontWeight: 700, margin: '0 0 6px' },
  subtitle: { color: '#94a3b8', fontSize: 14, margin: 0 },
  field: { marginBottom: 18 },
  label: { display: 'block', color: '#94a3b8', fontSize: 13, marginBottom: 6 },
  input: { width: '100%', padding: '10px 14px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#f1f5f9', fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  btn: { width: '100%', padding: '12px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 8 },
  error: { background: '#450a0a', border: '1px solid #b91c1c', borderRadius: 8, color: '#fca5a5', padding: '10px 14px', marginBottom: 16, fontSize: 13 },
  ok: { background: '#052e16', border: '1px solid #15803d', borderRadius: 8, color: '#86efac', padding: '10px 14px', fontSize: 13, textAlign: 'center' },
  link: { color: '#3b82f6', textDecoration: 'none', fontWeight: 600 },
};
